import React from 'react'
import SidebarItem from './SidebarItem'
import HomeIcon from '@material-ui/icons/Home';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import HistoryIcon from '@material-ui/icons/History';
import YourVideosIcon from '@material-ui/icons/PlayCircleOutline';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import LikedVideosIcon from '@material-ui/icons/ThumbUpAlt';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LocalMoviesIcon from '@material-ui/icons/LocalMovies';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import SettingsIcon from '@material-ui/icons/Settings';
import './Sidebar.css'
function Sidebar() {
    return (
        <div className="sidebar">
            <SidebarItem selected Icon={HomeIcon} title="Home"/>
            <SidebarItem Icon={WhatshotIcon} title="Trending"/>
            <SidebarItem Icon={SubscriptionsIcon} title="Subscriptions"/>
            <hr/>
            <SidebarItem Icon={VideoLibraryIcon} title="Library"/>
            <SidebarItem Icon={HistoryIcon} title="History"/>
            <SidebarItem Icon={YourVideosIcon} title="Your Videos"/>
            <SidebarItem Icon={WatchLaterIcon} title="Watch Later"/>
            <SidebarItem Icon={LikedVideosIcon} title="Liked Videos "/>
            <hr/>
            <h4>MORE FROM YOUTUBE</h4>
            <SidebarItem Icon={YouTubeIcon} title="YouTube Premium "/>
            <SidebarItem Icon={LocalMoviesIcon} title="Movies"/>
            <SidebarItem Icon={SportsEsportsIcon} title="Gaming"/>
            <hr/>
            <SidebarItem Icon={SettingsIcon} title="Settings"/>
        </div>
    )
}

export default Sidebar 
